<!-- resources/js/Layout/DefaultLayout.vue -->
<template>
  <div class="min-h-screen flex flex-col bg-background text-foreground">
    <AppHeader />
    <FlashToast />
    <main class="flex-grow">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
import AppHeader  from '@/Layout/Header.vue'
import AppFooter  from '@/Layout/Footer.vue'
import FlashToast from '@/Components/Feedback/FlashToast.vue'
</script>
